export default {
  throwError({ commit }, error) {
    commit("setError", error);
  },
  throwDefaultError({ commit }, e) {
    if (e.response && e.response.data && e.response.data.error) {
      const { error } = e.response.data;
      const renderedError = { code: error.code, title: error.text, detail: error.message };
      commit("setError", renderedError);
    } else {
      const renderedError = {
        code: e.status || 500,
        title: e.statusText || "Une erreur inconnue est survenue",
        detail: e.data || null
      };
      commit("setError", renderedError);
    }
  }
};
